
import { defineComponent, PropType } from 'vue'
import { iField, iQuery, iFilter } from '../../QBE'
import Dialog from 'primevue/dialog'
import KnFabButton from '@/components/UI/KnFabButton.vue'
import Message from 'primevue/message'
import QBEHavingDialogDescriptor from './QBEHavingDialogDescriptor.json'
import QBEHavingCard from './QBEHavingCard.vue'

const crypto = require('crypto')

export default defineComponent({
    name: 'qbe-having-dialog',
    components: { Dialog, KnFabButton, Message, QBEHavingCard },
    props: { visible: { type: Boolean }, havingDialogData: { type: Object as PropType<{ field: iField; query: iQuery }> }, entities: { type: Array } },
    emits: ['save', 'close'],
    data() {
        return {
            QBEHavingDialogDescriptor,
            havings: [] as any[],
            nextHavingIndex: -1
        }
    },
    watch: {
        havingDialogData() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            if (!this.havingDialogData || !this.havingDialogData.field || !this.havingDialogData.query) return

            this.havings = []
            this.havingDialogData.query.havings.forEach((having: iFilter) => {
                if (having.leftOperandValue === this.havingDialogData?.field.id) {
                    this.havings.push({ ...having })
                }
            })
            this.nextHavingIndex = crypto.randomBytes(16).toString('hex')
        },
        addNewHaving() {
            const field = this.havingDialogData?.field
            if (field) {
                this.havings.push({
                    filterId: 'having' + this.nextHavingIndex,
                    filterDescripion: 'having' + this.nextHavingIndex,
                    filterInd: this.nextHavingIndex,
                    promptable: false,
                    leftOperandAggregator: field.funct,
                    leftOperandValue: field.id,
                    leftOperandDescription: field.entity + ': ' + field.funct + ' (' + field.alias + ')',
                    leftOperandLongDescription: field.entity + ': ' + field.funct + ' (' + field.alias + ')',
                    leftOperandType: field.type === 'inline.calculated.field' || field.attributes?.type === 'inLineCalculatedField' ? 'inline.calculated.field' : 'Field Content',
                    leftOperandDefaultValue: null,
                    leftOperandLastValue: null,
                    operator: 'EQUALS TO',
                    rightOperandAggregator: '',
                    rightOperandValue: [],
                    rightOperandDescription: '',
                    rightOperandLongDescription: '',
                    rightOperandType: 'Static Content',
                    rightType: '',
                    rightOperandDefaultValue: [''],
                    rightOperandLastValue: [''],
                    booleanConnector: 'AND',
                    deleteButton: false,
                    color: '',
                    entity: field.entity
                })
                this.nextHavingIndex = crypto.randomBytes(16).toString('hex')
            }
        },
        removeHaving(having: iFilter) {
            const index = this.havings.findIndex((el: iFilter) => el.filterId === having.filterId)
            if (index !== -1) this.havings.splice(index, 1)
        },
        closeDialog() {
            this.$emit('close')
        },
        save() {
            this.$emit('save', this.havings, this.havingDialogData?.field)
        }
    }
})
